import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="center-msg">Loading...</div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  return children;
}
